module.exports = __webpack_public_path__ + "static/media/proteoglycansampoules.54a45c09.png";